var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"no-data"},[_c('img',{attrs:{"src":require("./assets/no-data.png"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"desc"},[_vm._t("default",function(){return [_vm._v("暂无内容")]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fb0c008","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/no-data/index.vue
// module id = null
// module chunks = 